import { taskService } from "../../services";
import { ITask } from "../../customTypings/task/Task";
import { showToastError } from "../../utils";
import dayjs from "dayjs";

export const useTaskFormSubmission = (
  visibleRecurring: boolean,
  allTaskTypes: any[],
  currentUser: any,
  handleTaskSuccess: (response: any, newTask: ITask, allUsers: any[]) => Promise<void>,
  setAlertVariant: (variant: string) => void,
  onClose: (added: boolean) => void,
  allUsers: any[]
) => {
  const handleSubmit = (values: any, setSubmitting: (submitting: boolean) => void) => {
    const typeLabel = allTaskTypes?.find((type) => type.value === values.taskTypeId)?.label || "Task";
    const taskName = values.name?.trim()
      ? values.name.trim()
      : typeLabel;

    const newTask: ITask = {
      id: undefined,
      taskTypeId: values.taskTypeId,
      userId: values.userId,
      creatorId: currentUser ? currentUser.identity.id : "",
      name: taskName,
      location: values.location,
      creationDate: visibleRecurring ? dayjs.utc(dayjs(new Date()).format("YYYY-MM-DD") + " " + values.startTime).toDate() : dayjs.utc(values.creationDate + " " + values.startTime).toDate(),
      dueDate: visibleRecurring ? dayjs.utc(dayjs(new Date()).format("YYYY-MM-DD") + " " + values.endTime).toDate() : dayjs.utc(values.dueDate + " " + values.endTime).toDate(),
      completedDate: undefined,
      originalDueDate: dayjs.utc(values.dueDate + " " + values.endTime).toDate(),
      notes: values.notes,
      days: values.days.join(","),
      recursiveInterval: values.recursiveInterval,
      recursiveDuration: values.recursiveDuration,
      commenceDate: values.commenceDate,
      addToCalendar: values.addToCalendar,
      dayOfMonth: values.dayOfMonth,
      yearlyDate: values.yearlyDate
    };

    return taskService.add(newTask).then(
      async (response) => {
        setSubmitting(false);
        if (response.status !== "Failure") {
          await handleTaskSuccess(response, newTask, allUsers);
          onClose(true);
        } else {
          setAlertVariant("danger");
          showToastError(response.message);
        }
      },
      (error: any) => {
        setAlertVariant("danger");
        if (error.status === 400 && error.errors) {
          Object.keys(error.errors).forEach((key) => {
            const messages = error.errors[key];
            if (Array.isArray(messages)) {
              messages.forEach((message) => showToastError(message));
            }
          });
        } else {
          showToastError("An unexpected error occurred!");
        }
        setSubmitting(false);
      }
    );
  };

  return { handleSubmit };
};
